import { Container, IconButton } from "@mui/material";
import Stack from '@mui/material/Stack';
import Typography from "@mui/material/Typography";
import Masonry from '@mui/lab/Masonry';
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { AppStoreButton } from "src/components/AppStoreButton";
import styles from 'src/styles/footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <Container sx={{
        pt: 3,
        justifyContent: 'center', // Center horizontally
        alignItems: 'center', // Center vertically
      }}>
        <Masonry columns={{ xs: 1, md:4 }} spacing={2}>
          <Stack spacing={1.5} alignItems="center">
            <Typography variant="h6">Resources</Typography>
            <ul className={styles.footerLinks}>
              <li><a className={styles.linkDark} href="/how-to-become-a-trainer.html">How to Become a Trainer</a></li>
            </ul>
            <ul className={styles.footerLinks}>
              <li><a className={styles.linkDark} href="/trainer-success-guide.html">Trainer Success Guide</a></li>
            </ul>
          </Stack>
          <Stack spacing={1.5} alignItems="center">
            <Typography variant="h6">Legal</Typography>
            <ul className={styles.footerLinks}>
              <li><a className={styles.linkDark} href="/terms-and-conditions.html">Terms & Conditions</a></li>
              <li><a className={styles.linkDark} href="/privacy-policy.html">Privacy Policy</a></li>
              <li><a className={styles.linkDark} href="/participation-term.html">Participation Terms</a></li>
            </ul>
          </Stack>
          <Stack spacing={1.5} alignItems="center">
            <Typography variant="h6">Contact</Typography>
            <ul className={styles.footerLinks}>
              <li><a className={styles.linkDark} href="mailto:contact@fitu.sg">contact@fitu.sg</a></li>
            </ul>
          </Stack>
          <Stack spacing={1.5} alignItems="center">
            <Typography variant="h6">Apps</Typography>
            <AppStoreButton />
          </Stack>
        </Masonry>
      </Container>
      <Container sx={{ padding: 4 }}>
        <Stack
          direction="row"
          sx={{
            justifyContent: 'center', // Center horizontally
            alignItems: 'center', // Center vertically
          }}>
          <div style={{ marginRight: "5rem" }}>Copyright &copy; FIT TECHNOLOGY PTE. LTD. 2024</div>
          <IconButton href="https://www.instagram.com/fitu_sg?igsh=eW81cnhjeGV4ZGVq" sx={{ color: "#6c63ff", marginRight: 2 }}>
            <InstagramIcon />
          </IconButton>
          <IconButton href="https://wa.me/message/DWSLI3MIY3IQH1" sx={{ color: "#6c63ff" }}>
            <WhatsAppIcon />
          </IconButton>
        </Stack>
      </Container>
    </footer>
  )
}
